export default __webpack_public_path__ + "static/media/results-icon.4e681d93.svg";